import React, { Component } from 'react'
import { Form, Icon, Popup } from 'semantic-ui-react'
import SemanticDatepicker from 'react-semantic-ui-datepickers'
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css'
import './semanticDateField.scss'

export class DateInputField extends Component {
  constructor() {
    super()
    this.state = {
      wasFocused: false,
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.newValue !== this.state.newValue ||
      nextProps.rbCounterId !== this.state.rbCounterId
    ) {
      this.setState(
        { newValue: nextProps.newValue, rbCounterId: nextProps.rbCounterId },
        () => {
          this.props.fieldName === this.props.id + this.props.shipmentId &&
            this.props.onChange(
              this.props.isInteger
                ? parseFloat(
                  this.state.newValue.replace(/[^\d.-]/g, '')
                ).toFixed(2)
                : this.state.newValue
            )
        }
      )
    }
  }

  errorPopup = errors => {
    const error = errors.map((info, index) => {
      return (
        <div className='error' key={index}>
          * {info}
        </div>
      )
    })
    return (
      <Popup trigger={<Icon name='warning sign' size='small' color='red' />} content={error || ''} />
    )
  }

  emptyField = id => {
    !this.props.isInteger && this.props.onChange('')
    let element = document.getElementById(id)
    element.focus()
  }
  render() {
    const {
      id,
      iconPosition,
      width,
      type,
      onChange,
      onBlur,
      disabled,
      value,
      setINPUTID,
      penClicked,
      isInteger,
      shipmentId,
      handleFocus,
      label,
      numberOnly,
      errors,
      dateFormat,
      tz
    } = this.props
    const valueCopy = value;
    let redBgColor = "";
    if(errors && errors.length){
      redBgColor = "redBgColor";
    }
    return (
      <Form.Input width={width} className={`sematic-date-field ${redBgColor}`}>
        <>
        <label style={{width:'90%'}}>
        { this.props.errors && this.props.errors.length>0 && 
           this.errorPopup(this.props.errors)
          }
          {label} 
        </label>
        </>
        <SemanticDatepicker
          name={id}
          id={id + shipmentId}
          clearable={this.state.wasFocused}
          onDateChange={
            (value) => {
              if(valueCopy == value?.getTime() )return;
              onChange && this.state.wasFocused && onChange(value, value)
            }
          }
          onFocus={()=>{
            this.setState({wasFocused:true})
          }}
          selected={(value !== -999 && value > 0 && value !== undefined) ? new Date(new Date(value)): false}
          onBlur={event => onBlur && onBlur(new Date(event.target.value))}
          pointing={'left'}
          icon='calendar outline'
          format={dateFormat || 'MM/DD/YYYY'}
          disabled={disabled}
          clearOnSameDateClick={false}
        />
      </Form.Input>
    )
  }
}

export default DateInputField
